export const COLORS = {
    PRIMARY: '#26B67C',
    SECONDARY: '#0A2E57',
    WHITE: '#FFFFFF',
    BLACK: '#000000',
    TRANSPARENT: 'transparent',
    GRAY: '#C4C4C4',
    LIGHT_GRAY: '#E7E6EB',
    ORANGE: '#FF9900',
    INFOBLUE: '#D4E5F7',
    SILVER: '#F4F6F7',
    DARK_GRAY: '#EAEDF0',
};
export const FONT_WEIGHTS = {
    LIGHT: 300,
    REGULAR: 400,
    BOLD: 700,
};
export const APP_BAR_HEIGHT = 80;
